import SearchConstValues from "@/ecm/variables/SearchConstValues";

export default {
    GetDisplayValueFromFieldValue(condition,context) {
        switch (condition) {
            case SearchConstValues.Today:
                return context.$t("Today");
            case SearchConstValues.MySelf:
                return context.$t("Myself");
            case SearchConstValues.MySelf_Id:
                return context.$t("MyselfId");
            case SearchConstValues.Empty || SearchConstValues.NotEmpty:
                return "";
            default:
                return condition
                    .replace(
                        SearchConstValues.DaysBeforeToday,
                        `${context.$t("DaysBeforeToday")} ${context.$t("Today")}`
                    )
                    .replace(
                        SearchConstValues.DaysAfterToday,
                        `${context.$t("DaysAfterToday")} ${context.$t("Today")}`
                    );
        }
    }
};